import { get, getExport } from "helpers/api_helper"

export const fetchAnalyticsAccess = () => get("/admin/analytics/access")

export const fetchAnalyticsView = query =>
  get("/admin/analytics", { params: query })

export const fetchAnalyticsExport = query =>
  getExport("/admin/analytics/export", {
    params: query,
    responseType: "arraybuffer",
  })
